import React from "react";

const GBTable = ({ t }) => (
  <div>
    <table className="gb-testing">
      <thead>
        <tr>
          <td className="header">{t("fpgb.table_header")}</td>
        </tr>
      </thead>
      <tbody>
        <tr><td>75% &ge; 14.0 cm (duck) / 15.0 cm (goose)</td></tr>
        <tr><td>80% &ge; 14.5 cm (duck) / 15.5 cm (goose)</td></tr>
        <tr><td>85% &ge; 15.5 cm (duck) / 16.5 cm (goose)</td></tr>
        <tr><td>90% &ge; 16.0 cm (duck) / 17.0 cm (goose)</td></tr>
        <tr><td>95% &ge; 16.5 cm (duck) / 17.5 cm (goose)</td></tr>
      </tbody>
    </table>
  </div>
);

const FPContentGB = ({ t }) => (
  <>    
    <p>{t("fpgb.p1")}</p>
    <p>{t("fpgb.p2")}</p>
    <p>{t("fpgb.p3")}</p>
    <GBTable t={t} />
    <p>{t("fpgb.p4")}</p>
    <p>
      <br /><br />
      {t("fpgb.cta_prefix")}
      <a href="http://cdn.trackmydown.com/IDFL_china-gb-and-idfb-fill-power-methods-comparison.pdf" target="_blank" rel="noopener noreferrer">
        {t("fpgb.cta_text")}
      </a>.
      <br /><br />
    </p>
    <br /><br />
  </>
);

const FillPowerGB = (props) => {
  const { t, changeWord } = props;

  return (
    <div className="content-ac fp-gb hide" data-slug="FP2">
      <input
        className="ac-input top"
        id="ac-gb"
        name="ac-gb"
        data-id="2401"
        data-slug="FP2"
        type="checkbox"
        onChange={() => changeWord('fp2 clicked')}
      />

      <label className="ac-label" htmlFor="ac-gb">
        {t("fpgb.label")}
      </label>

      <article className="ac-text ac-gb">
        <div className="single-post-interior" tabIndex="0">
          <FPContentGB t={t} />
        </div>
      </article>
    </div>
  );
};

export default FillPowerGB;
